import { ButtonBase, Image, Text } from '@belong/ui';
import { AGREEMENT_FLOW_STRINGS } from 'strings/agreement-flow.strings';
import styles from './intro-belong-standards.module.css';

const BELONG_STANDARDS_BADGE_SRC =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/modals/belong-standards/belong_standard_badge_sm_light.png';

type Props = {
  title: string;
  subtitle?: string;
  items: string[];
  onLearnMore: () => void;
};

export function IntroBelongStandards({
  title,
  subtitle,
  items,
  onLearnMore,
}: Props) {
  return (
    <div className={styles.belongStandardsCard}>
      <div className="flex flex-col items-center gap-xs text-center">
        <div className="flex flex-col items-center gap-xs">
          <div className="h-[105px] w-[120px]">
            <Image
              src={BELONG_STANDARDS_BADGE_SRC}
              className="object-contain"
              alt="Belong Standard Badge"
            />
          </div>
          <Text fontWeight="semibold" className={styles.gradientText}>
            {title}
          </Text>
          {subtitle && <Text className="text-navy">{subtitle}</Text>}
        </div>
        <ButtonBase onClick={onLearnMore}>
          <Text fontWeight="semibold" className="uppercase">
            {AGREEMENT_FLOW_STRINGS.learnMore}
          </Text>
        </ButtonBase>
      </div>

      <div className="my-xl border-x-0 border-b-0 border-t border-dashed border-gray" />

      <div className="flex flex-col items-center gap-lg md:flex-row md:items-start md:justify-between md:gap-0">
        {items.map((text, index) => (
          <div key={index} className="flex flex-col items-center gap-xs">
            <div className="flex h-[26px] w-[26px] items-center justify-center rounded-[2px] bg-green">
              <Text fontWeight="semibold" className="text-white">
                {index + 1}
              </Text>
            </div>
            <Text className="text-center">{text}</Text>
          </div>
        ))}
      </div>
    </div>
  );
}
